const DESKTOP_BREAKPOINT = 768;

function initShowSubNav() {
  const subNav = document.getElementById('show-sub-nav');

  if (!subNav) {
    return;
  }

  const nav = document.querySelector('nav');
  const header = document.querySelector('body.show-detail header, body.brand-detail header');
  const subNavToggle = subNav.querySelector('.sub-nav-toggle');
  const subNavLinks = Array.from(subNav.querySelectorAll('.sub-nav-link'));
  const showContentBlocks = Array.from(document.querySelectorAll('.show-content-block, .brand-content .genre-group'));

  if (!nav || !header || !subNavToggle) {
    subNav.classList.remove('is-visible');
    subNav.setAttribute('aria-hidden', 'true');
    return;
  }

  const stickySpacer = document.createElement('div');
  stickySpacer.className = 'show-sub-nav-spacer';
  stickySpacer.setAttribute('aria-hidden', 'true');
  subNav.insertAdjacentElement('afterend', stickySpacer);

  const closeTray = () => {
    subNav.classList.remove('is-open');
    subNavToggle.setAttribute('aria-expanded', 'false');
  };

  const setVisible = (isVisible) => {
    subNav.classList.toggle('is-visible', isVisible);
    subNav.setAttribute('aria-hidden', String(!isVisible));

    if (!isVisible) {
      closeTray();
    }
  };

  const updateTrayMaxHeight = () => {
    const viewportHeight = window.innerHeight || document.documentElement.clientHeight || 0;
    const isDesktop = window.innerWidth >= DESKTOP_BREAKPOINT;
    const subNavTop = subNav.getBoundingClientRect().top;
    const toggleHeight = subNavToggle.getBoundingClientRect().height || subNavToggle.offsetHeight || 0;
    const availableHeight = isDesktop
      ? Math.floor(viewportHeight - 24)
      : Math.floor(viewportHeight - subNavTop - toggleHeight - 8);
    const trayMaxHeight = Math.max(120, availableHeight);

    subNav.style.setProperty('--sub-nav-tray-max-height', `${trayMaxHeight}px`);
  };

  const updateDesktopPlacement = () => {
    if (showContentBlocks.length === 0) {
      return;
    }

    const viewportWidth = window.innerWidth || document.documentElement.clientWidth || 0;
    const viewportHeight = window.innerHeight || document.documentElement.clientHeight || 0;
    const firstBlock = showContentBlocks[0];
    const lastBlock = showContentBlocks[showContentBlocks.length - 1];
    const firstBlockRect = firstBlock.getBoundingClientRect();
    const lastBlockRect = lastBlock.getBoundingClientRect();
    const firstTopViewport = firstBlockRect.top;

    const subNavRect = subNav.getBoundingClientRect();
    const subNavHeight = subNavRect.height || subNav.offsetHeight || 0;
    const subNavWidth = subNavRect.width || subNav.offsetWidth || 0;
    const centerTopViewport = (viewportHeight - subNavHeight) / 2;
    const maxTopViewport = lastBlockRect.bottom - subNavHeight;
    const clampedTop = Math.max(firstTopViewport, Math.min(centerTopViewport, maxTopViewport));

    const firstInner = firstBlock.querySelector('.inner');
    const contentRight = firstInner?.getBoundingClientRect().right || firstBlockRect.right;
    const halfWidth = subNavWidth / 2;
    const edgePadding = 12;
    const gutterLeft = contentRight;
    const gutterRight = viewportWidth;
    const gutterCenter = gutterLeft + ((gutterRight - gutterLeft) / 2);
    const minCenter = gutterLeft + halfWidth + edgePadding;
    const maxCenter = gutterRight - halfWidth - edgePadding;
    const clampedLeft = maxCenter >= minCenter
      ? Math.max(minCenter, Math.min(gutterCenter, maxCenter))
      : minCenter;

    subNav.style.setProperty('--sub-nav-desktop-top', `${Math.round(clampedTop)}px`);
    subNav.style.setProperty('--sub-nav-desktop-left', `${Math.round(clampedLeft)}px`);
  };

  const getScrollOffset = () => {
    const navHeight = nav.getBoundingClientRect().height || nav.offsetHeight || 0;
    return navHeight;
  };

  const scrollToHashWithOffset = (hash) => {
    if (!hash) {
      return;
    }

    const target = document.querySelector(hash);

    if (!target) {
      return;
    }

    const targetTop = window.scrollY + target.getBoundingClientRect().top;
    const offsetTop = Math.max(0, targetTop - getScrollOffset());

    window.scrollTo({
      top: offsetTop,
      behavior: 'smooth',
    });

    if (window.history?.pushState) {
      window.history.pushState(null, '', hash);
    } else {
      window.location.hash = hash;
    }
  };

  const updateState = () => {
    const isMobile = window.innerWidth < DESKTOP_BREAKPOINT;

    if (!isMobile) {
      const isVisible = showContentBlocks.length > 0;
      subNav.classList.add('is-desktop');
      setVisible(isVisible);

      if (!isVisible) {
        return;
      }

      subNav.style.removeProperty('--show-sub-nav-sticky-top');
      subNav.classList.remove('is-stuck');
      stickySpacer.style.height = '0px';
      closeTray();
      updateDesktopPlacement();
      updateTrayMaxHeight();
      return;
    }

    subNav.classList.remove('is-desktop');
    subNav.style.removeProperty('--sub-nav-desktop-top');
    subNav.style.removeProperty('--sub-nav-desktop-left');
    setVisible(true);

    const navHeight = nav.getBoundingClientRect().height || nav.offsetHeight || 0;
    subNav.style.setProperty('--show-sub-nav-sticky-top', `${Math.round(navHeight)}px`);

    const headerBottom = header.getBoundingClientRect().bottom;
    const shouldStick = headerBottom <= navHeight;
    subNav.classList.toggle('is-stuck', shouldStick);

    const collapsedHeight = subNavToggle.getBoundingClientRect().height || subNavToggle.offsetHeight || 0;
    stickySpacer.style.height = shouldStick ? `${Math.round(collapsedHeight)}px` : '0px';

    updateTrayMaxHeight();
  };

  subNavToggle.addEventListener('click', () => {
    if (subNav.classList.contains('is-desktop')) {
      return;
    }

    if (!subNav.classList.contains('is-visible')) {
      return;
    }

    updateTrayMaxHeight();

    const isOpen = !subNav.classList.contains('is-open');
    subNav.classList.toggle('is-open', isOpen);
    subNavToggle.setAttribute('aria-expanded', String(isOpen));
  });

  subNavLinks.forEach((link) => {
    link.addEventListener('click', (event) => {
      const targetUrl = new URL(link.href, window.location.href);
      const isSamePagePath = targetUrl.pathname === window.location.pathname;
      const isSamePageSearch = targetUrl.search === window.location.search;

      if (targetUrl.hash && isSamePagePath && isSamePageSearch) {
        event.preventDefault();
        scrollToHashWithOffset(targetUrl.hash);
      }

      closeTray();
    });
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      closeTray();
    }
  });

  updateState();
  window.addEventListener('scroll', updateState, { passive: true });
  window.addEventListener('resize', updateState);
  window.addEventListener('pageshow', updateState);
}

initShowSubNav();
